import { createContext } from 'react';

import { UserModel } from '@vestico/model';

export interface UserContextProps {
  user: UserModel | null;
  uid?: string;
  reloadUser?: (isReset: boolean) => void;
  fetchUser?: () => void;
}

export const UserContext = createContext<UserContextProps>({} as UserContextProps);
